import React, { useEffect } from "react";

export const ExternalRedirect: React.FC<{ href: string }> = ({ href }) => {
    useEffect(() => {
        window.location.replace(href);
    }, [href]);

    return null;
};
